import React, {useEffect} from "react";
import {useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";
import {selectUserData} from "../features/store";
import Fetching from "./Fetching";

const Redirect = ({prevPath}) => {
  const navigate = useNavigate();
  const userData = useSelector(selectUserData);
  const validPath = [
    "/dashboard",
    "/main",
    "/manage-accounts",
    "/config",
    "/report",
  ];
  function redirect() {
    let path;
    const token = userData.token;

    if (token === "") {
      path = "/log-in";
    } else if (userData.reset) {
      path = "/reset-password";
    } else if (validPath.includes(prevPath)) {
      path = prevPath;
    } else {
      path = "/dashboard";
    }
    console.log("-> | Redirect to " + path);
    navigate(path);
    return;
  }

  useEffect(() => {
    localStorage.setItem("prevPath", prevPath);
    redirect();
  }, []);

  return <Fetching title={"Redirecting"} />;
};

export default Redirect;
